import React from 'react';
import { Button } from 'react-bootstrap';


const Buttton = ({ children, as, type, value, onClick, className, disabled }) => {
    return (
        <Button children={children} as={as} type={type} value={value} onClick={onClick} className={className} disabled={disabled}/>
    )
}

export default Buttton;
